import React, { memo, useState, useEffect } from 'react';
import { RenderHTML } from '@dmm/react-common-components';
import classnames from 'classnames';
import './styles.css';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { getMessages } from '../../../../tppServices/translations/messages';
import ConversationalCta from '../../../../components/ConversationalCta';
import { getRenderedHeight } from '../../../../utils/commonHelper';


const DataHTML = ({ data, isMultiItem = false, elementSelector, showConversionalCTA = false, icon, onOpenContactForm, title, content, id }) => {
  const [showMoreToggle, setShowMoreToggle] = useState(false);

  const [renderedHeight, setRenderedHeight] = useState(0);

  useEffect(() => {
    if (!isMultiItem && elementSelector) {
      setRenderedHeight(getRenderedHeight(data, elementSelector));
    }
  }, []);

  const intl = useIntl();
  const t = intl.formatMessage;
  const messages = getMessages();

  return (
    <div className="data-html">
      {isMultiItem
        ? data.map((prop, index) => (
          <div key={index}>
            {prop.title && <h4>{prop.title}</h4>}
            <RenderHTML html={prop.value} />
          </div>
        ))
        : (
          <>
          <div className={classnames(
            'data-html-inner-wrapper',
            { 'show-more': showMoreToggle }
          )}>
            <RenderHTML html={data} />
            {renderedHeight > 170 && (
              <div className="show-more-less-interaction">
                <button onClick={() => setShowMoreToggle((prev) => !prev)}>
                  {!showMoreToggle ? t(messages.showMore) : t(messages.showLess)}
                </button>
              </div>
            )}
          </div>
            {
              showConversionalCTA && showMoreToggle &&
                <ConversationalCta
                id={id}
                enabled={true}
                variant="button"
                classNames={{ icon: true }}
                icon={icon}
                onClick={onOpenContactForm}
                title={title}
                content={content}
              />
            }
            </>
        )
      }
    </div>
  );
};

DataHTML.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        value: PropTypes.string.isRequired
      })
    )
  ]).isRequired,
  isMultiItem: PropTypes.bool,
  elementSelector: PropTypes.string,
  showConversionalCTA: PropTypes.bool,
  icon: PropTypes.string,
  onOpenContactForm: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.string,
  id: PropTypes.string,
};


export default memo(DataHTML);
